angular.module('AccountingBoxApp')
.directive('abuploader', function() {
return {
    restrict: 'E',
    templateUrl:'app/components/ABUploader/ABUploader.html',
    controller: 'ABUploaderCtrl'
};
});
